export default __webpack_public_path__ + "static/media/Kalinga.56910d35.ttf";